import {
	AMD_HOST,
	FEATURE_TOGGLES_PATH,
} from '../global-constants.js';
import { ddcLog } from '../utils/logger.js';

export const fetchFeatureToggles = async (dealerId, config = {}) => {
	if (!dealerId) {
		ddcLog('Feature toggles: no dealerId resolved, fetching without query params');
	}

	const { useStaging } = config;
	const host = useStaging ? AMD_HOST.staging : AMD_HOST.prod;
	const dealerQuery = dealerId ? `?dealerId=${dealerId}` : '';
	const url = `https://${host}${FEATURE_TOGGLES_PATH}${dealerQuery}`;

	try {
		const response = await fetch(url, {
			method: 'POST',
			credentials: 'omit',
			headers: {
				Accept: 'application/json',
			},
		});

		if (!response.ok) {
			ddcLog('Feature toggles: non-OK response', response.status);
			return null;
		}

		const { featureToggles } = await response.json();
		ddcLog('Feature toggles loaded:', featureToggles);
		return featureToggles;
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Feature toggles request error: ', err);
		return null;
	}
};

export default fetchFeatureToggles;
